import React from 'react';

type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#000000',
};

const RefreshIcon = function RefreshIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="refresh-icon">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.00007 16.3452C4.58186 16.3452 1 12.7633 1 8.34467C1 5.96724 2.04127 3.83816 3.6882 2.37392H2.28059C1.88474 2.37392 1.564 2.05302 1.564 1.65733V1.37209C1.564 0.976242 1.8849 0.65551 2.28059 0.65551H6.26729C6.27011 0.65551 6.2726 0.654846 6.27542 0.654846H6.56066C6.75867 0.654846 6.93827 0.735441 7.06777 0.865291C7.19762 0.995142 7.27789 1.17408 7.27789 1.37211V1.65735C7.27789 1.65967 7.27722 1.66183 7.27722 1.66398V5.65217C7.27722 6.04802 6.95633 6.36875 6.56064 6.36875H6.2754C5.87955 6.36875 5.55881 6.04786 5.55881 5.65217V3.13477C3.85734 4.25882 2.73162 6.18319 2.73162 8.37488C2.73162 11.8472 5.54655 14.6619 9.01866 14.6619C12.4909 14.6619 15.3057 11.847 15.3057 8.37488C15.3057 5.66694 13.5906 3.36572 11.19 2.48055C11.2069 2.46529 11.2213 2.44721 11.2377 2.43113C11.0756 2.30824 10.9693 2.11537 10.9693 1.89646L10.9691 1.62863C10.9691 1.25683 11.2706 0.955352 11.6424 0.955352H11.9002C11.9039 0.936612 11.9084 0.917707 11.9119 0.898968C11.9876 0.928653 12.0606 0.964309 12.1354 0.99615C12.1644 1.00643 12.1919 1.01854 12.2188 1.03247C15.0311 2.27226 17 5.07342 17 8.34435C17 12.7625 13.4179 16.3448 8.99951 16.3448L9.00007 16.3452Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
    </svg>
  );
};
RefreshIcon.defaultProps = defaultProps;
export default RefreshIcon;
